module.exports = __webpack_public_path__ + "static/media/otago.ff5d28e6.png";